import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cover",
  "use": "cover-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"cover\"><title>cover</title><g id=\"cover_Layer_8\" data-name=\"Layer 8\"><path d=\"M18,1H3A2,2,0,0,0,1,3V18a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V3A2,2,0,0,0,18,1ZM3,2H18a1,1,0,0,1,1,1V9.93L16.53,7.87l-6.3,4.36L8,10.37,2,14.55V3A1,1,0,0,1,3,2ZM18,19H3a1,1,0,0,1-1-1V15.76l6-4.13,6.21,5.25.64-.76L11,12.9l5.45-3.77L19,11.23V18A1,1,0,0,1,18,19Z\" /><circle cx=\"6\" cy=\"6\" r=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cover.svg
// module id = Oa3d
// module chunks = 4